<template>
	<div class="create-race">
		<v-card class="create-race-card rounded-lg">
			<div class="create-race-header">
				<h1>Creación de carreras</h1>
			</div>
			<v-form
				ref="createRaceForm"
				v-model="formValid"
				class="create-race-form"
			>
				<!-- Name of the race -->
				<v-text-field
					label="Nombre de la carrera"
					v-model="name"
					:rules="[rules.notEmpty]"
				></v-text-field>

				<v-textarea
					label="Descripción de la ruta"
					v-model="description"
				></v-textarea>

				<div class="card-row">
					<!-- Range date selector -->
					<v-dialog
						ref="startDateDialog"
						v-model="startDateModal"
						:return-value.sync="startDate"
						persistent
						width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								:value="startDate | formatDate"
								label="Fecha de inicio"
								prepend-icon="mdi-calendar"
								readonly
								v-bind="attrs"
								v-on="on"
								:rules="[rules.notEmpty, correctDates]"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="startDate"
							scrollable
							locale="es-ES"
							first-day-of-week="1"
							reactive
							@change="$refs.startDateDialog.save(startDate)"
						>
							<v-spacer></v-spacer>
							<v-btn
								text
								color="primary"
								@click="startDateModal = false"
								>Cancel</v-btn
							>
						</v-date-picker>
					</v-dialog>

					<v-dialog
						ref="startTimeDialog"
						v-model="startTimeModal"
						:return-value.sync="startTime"
						persistent
						width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								:value="startTime"
								label="Hora de inicio"
								prepend-icon="mdi-calendar"
								readonly
								v-bind="attrs"
								v-on="on"
								:rules="[rules.notEmpty, correctDates]"
							></v-text-field>
						</template>
						<v-time-picker
							v-model="startTime"
							scrollable
							reactive
							format="24hr"
							@change="$refs.startTimeDialog.save(startTime)"
						>
							<v-spacer></v-spacer>
							<v-btn
								text
								color="primary"
								@click="startTimeModal = false"
								>Cancel</v-btn
							>
						</v-time-picker>
					</v-dialog>
				</div>

				<div class="card-row">
					<!-- Range date selector -->
					<v-dialog
						ref="finishDateDialog"
						v-model="finishDateModal"
						:return-value.sync="finishDate"
						persistent
						width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								:value="finishDate | formatDate"
								label="Fecha de fin"
								prepend-icon="mdi-calendar"
								readonly
								v-bind="attrs"
								v-on="on"
								:rules="[rules.notEmpty, correctDates]"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="finishDate"
							scrollable
							locale="es-ES"
							first-day-of-week="1"
							reactive
							:allowed-dates="allowedDates"
							@change="$refs.finishDateDialog.save(finishDate)"
						>
							<v-spacer></v-spacer>
							<v-btn
								text
								color="primary"
								@click="finishDateModal = false"
								>Cancel</v-btn
							>
						</v-date-picker>
					</v-dialog>

					<v-dialog
						ref="finishTimeDialog"
						v-model="finishTimeModal"
						:return-value.sync="finishTime"
						persistent
						width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								:value="finishTime"
								label="Hora de fin"
								prepend-icon="mdi-calendar"
								readonly
								v-bind="attrs"
								v-on="on"
								:rules="[rules.notEmpty, correctDates]"
							></v-text-field>
						</template>
						<v-time-picker
							v-model="finishTime"
							scrollable
							reactive
							format="24hr"
							@change="$refs.finishTimeDialog.save(finishTime)"
						>
							<v-spacer></v-spacer>
							<v-btn
								text
								color="primary"
								@click="finishTimeModal = false"
								>Cancel</v-btn
							>
						</v-time-picker>
					</v-dialog>
				</div>

				<v-text-field
					prepend-icon="mdi-currency-eur"
					label="Precio de la carrera"
					v-model="price"
					lang="es"
					type="number"
					:rules="[rules.notEmpty, rules.positive]"
				>
				</v-text-field>

				<v-combobox
					prepend-icon="mdi-tag-multiple"
					v-model="tags"
					label="Etiquetas carrera"
					multiple
					clearable
					chips
					:items="existingTags"
					:loading="tagsLoading"
					:search-input.sync="searchInput"
					@change="searchInput = ''"
				></v-combobox>

				<v-autocomplete
					prepend-icon="mdi-selection-marker"
					v-model="circuit"
					label="Añadir carrera a circuito"
					clearable
					:items="circuits"
					:loading="circuitsLoading"
					:search-input.sync="circuitSearchInput"
					@change="circuitSearchInput = ''"
				>
					<template #selection="{ item }">
						{{ item.name }}
					</template>

					<template #item="{ item }">
						{{ item.name }}
					</template>
				</v-autocomplete>

				<!-- GPX file upload -->
				<v-file-input
					@change="fileUploaded"
					accept=".gpx, application/gpx+xml"
					cleareable
					ref="fileInput"
					label="Sube un archivo GPX o dibuja una ruta"
				></v-file-input>

				<!-- Leaflet route creator -->
				<h2>
					Click izquierdo para crear marcadores y click derecho para
					borrarlos
				</h2>
				<!-- Leaflet map -->
				<v-switch
					inset
					color="info"
					label="Habilitar edición, esto tardará unos segundos. (Más de 500 puntos ralentizan enormemente el navegador)"
					v-model="editRoute"
				></v-switch>
				<div class="map" id="map"></div>

				<!-- ACTION BUTTONS -->
				<v-card-actions class="card-actions">
					<!-- Button to cancel adding the race -->
					<v-btn
						@click="cancel"
						color="error"
						elevation="0"
						class="rounded-lg"
						:disabled="loading"
						>Cancelar</v-btn
					>

					<!-- Button to delete all waypoints -->
					<v-btn
						@click="resetRoute"
						color="warning"
						elevation="0"
						class="rounded-lg"
						:disabled="loading"
						>Borrar ruta</v-btn
					>
					<!-- Button to save the race -->
					<v-spacer></v-spacer>
					<v-btn
						@click="submit"
						color="success"
						:loading="loading"
						:disabled="loading || !formValid"
						elevation="0"
						class="rounded-lg"
						x-large
						>Crear ruta</v-btn
					>
				</v-card-actions>
			</v-form>
		</v-card>
	</div>
</template>

<script>
	import gpxToJs from "./../../utils/parse-gpx-route";
	import axios from "axios";
	import L from "leaflet";
	import "leaflet-editable";
	import moment from "moment";

	export default {
		name: "AdminCreateRoute",
		data() {
			return {
				//Component data
				loading: false,

				//Form data
				name: "",
				description: "",

				startDateModal: false,
				startDate: moment(new Date()).format("YYYY-MM-DD"),
				startTimeModal: false,
				startTime: moment(new Date()).format("HH:mm"),

				finishDateModal: false,
				finishDate: moment(new Date()).add("1", "day").format("YYYY-MM-DD"),
				finishTimeModal: false,
				finishTime: moment(new Date().setHours(0, 0, 0, 0)).format("HH:mm"),

				tags: [],
				existingTags: [],
				tagsLoading: false,
				searchInput: "",

				circuit: undefined,
				circuits: [],
				circuitsLoading: false,
				circuitSearchInput: undefined,

				file: "ejemplo",
				modalDateRange: false,
				price: 0,
				formValid: false,

				//Map data
				leafletRoute: [],
				editRoute: true,
				map: undefined,
				polyline: undefined,
				markers: [],
				draggin: false,

				//Form validation rules
				rules: {
					notEmpty: (v) => v !== "" || "El campo no puede estar vacío",
					positive: (v) => v >= 0 || "El precio no puede ser negativo",
				},
				correctDates: () => {
					if (
						this &&
						this.startDate &&
						this.startTime &&
						this.finishDate &&
						this.finishTime
					) {
						return (
							moment(
								`${this.startDate} ${this.startTime}`,
								"YYYY-MM-DD HH:mm"
							).valueOf() <
								moment(
									`${this.finishDate} ${this.finishTime}`,
									"YYYY-MM-DD HH:mm"
								).valueOf() ||
							"La fecha y hora de final debe ser posterior a la de inicio"
						);
					} else {
						return true;
					}
				},
			};
		},
		filters: {
			formatDate(date) {
				if (date === "") {
					return "";
				} else {
					return moment(date).locale("es-ES").format("ll");
				}
			},
		},
		watch: {
			startDate() {
				this.$refs.createRaceForm.validate();
			},
			finishDate() {
				this.$refs.createRaceForm.validate();
			},
			startTime() {
				this.$refs.createRaceForm.validate();
			},
			finishTime() {
				this.$refs.createRaceForm.validate();
			},
			editRoute(val) {
				if (val) {
					setTimeout(() => {
						this.polyline.enableEdit();
						this.polyline.editor.continueForward();
					}, 250);
				} else {
					this.polyline.disableEdit();
				}
			},
			/* circuit(val) {
					if (this.circuit) {
						this.startTime = moment(val.startDate).format("hh:mm");
						this.finishTime = moment(val.finishDate).format("hh:mm");
						this.startDate = val.startDate;
						this.finishDate = val.finishDate;
					}
				}, */
		},
		computed: {
			//Show date ranges in the text field
			dateRangeText() {
				if (this.startFinishDate[0] === "") {
					return "";
				} else {
					return this.startFinishDate.join(" -> ");
				}
			},
		},

		methods: {
			/**
			 * Set allowed dates
			 */
			allowedDates(date) {
				date = new Date(date).setHours(0, 0, 0, 0);

				//If the date is greater or equal to today, it is allowed
				return date >= moment(this.startDate).valueOf();
			},

			/**
			 * When a file is uploaded, convert it to JS object of coordinates
			 */
			async fileUploaded(e) {
				try {
					if (e) {
						this.$emit("loading", true);
						this.editRoute = false;
						this.polyline.setLatLngs([]);

						this.leafletRoute = await gpxToJs(e);

						this.polyline.setLatLngs(
							this.leafletRoute.map((coord) => [coord.x, coord.y])
						);

						this.map.fitBounds(this.polyline.getBounds());
					}
				} catch (error) {
					this.leafletRoute = [];
					this.$emit("snackbar-event", {
						color: "error",
						text: "No se puede procesar el archivo GPX introducido",
					});
					e = undefined;
				} finally {
					this.$emit("loading", false);
				}
			},

			/**
			 * When the user submits the form
			 */
			async submit() {
				try {
					this.$emit("loading", true);
					this.loading = true;
					this.$refs.createRaceForm.validate();

					this.leafletRoute = this.polyline
						.getLatLngs()
						.map((latlng) => ({ x: latlng.lat, y: latlng.lng }));

					if (this.formValid && this.leafletRoute.length >= 2) {
						let payload = {
							name: this.name,
							description: this.description,
							startDate: moment(
								`${this.startDate} ${this.startTime}`,
								"YYYY-MM-DD HH:mm"
							).format(),
							finishDate: moment(
								`${this.finishDate} ${this.finishTime}`,
								"YYYY-MM-DD HH:mm"
							).format(),
							price: this.price,
							tags: this.tags,
							route: this.leafletRoute,
							circuit: this.circuit ? this.circuit.id : null,
						};

						//Then show the snackbar
						this.$emit("snackbar-event", {
							color: "info",
							text:
								"Espere mientras se procesa y se genera la ruta...",
						});

						//Send the form and the object of coordinates to the back-end
						await axios.post("admin/create-route", payload);

						//Then show the snackbar
						this.$emit("snackbar-event", {
							color: "success",
							text: "Carrera creada con éxito",
						});

						//Go back to the main AdminRaceList
						this.$router.push({ name: "AdminRaceList" });
					} else {
						this.loading = false;
						//Show error snackbar
						this.$emit("snackbar-event", {
							color: "error",
							text:
								"Compruebe que todos los campos son correctos y que se haya dibujado una ruta",
						});
					}
					//Hide loading
				} catch (error) {
					console.log(error);
					if (error.response.data) {
						if (error.response.status === 401) {
							this.$router.push({ name: "AdminLogin" });
						}
						this.$emit("snackbar-event", {
							color: "error",
							text: error.response.data,
						});
					} else {
						//Show error snackbar
						this.$emit("snackbar-event", {
							color: "error",
							text:
								"Ha ocurrido un error, vuelva a intentarlo más tarde",
						});
					}
				} finally {
					//Hide loading
					this.$emit("loading", false);
					this.loading = false;
				}
			},

			/**
			 * Returns to main page if admin cancels
			 */
			cancel() {
				this.$router.push({ name: "AdminRaceList" });
			},

			/**
			 * Initializes leaflet map
			 */
			initializeMap() {
				//Workaround for webpack not importing the icons
				delete L.Icon.Default.prototype._getIconUrl;

				L.Icon.Default.mergeOptions({
					iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
					iconUrl: require("leaflet/dist/images/marker-icon.png"),
					shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
				});
				//End of workaround

				const satelliteStreetMap = L.tileLayer(
					"https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
					{
						attribution:
							'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
						maxZoom: 21,
						id: "mapbox/satellite-streets-v11",
						tileSize: 512,
						zoomOffset: -1,
						accessToken: process.env.VUE_APP_MAP_TOKEN,
					}
				);

				//Then add the tile layer for normal map
				const streetMap = L.tileLayer(
					"https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
					{
						attribution:
							'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
						maxZoom: 21,
						id: "mapbox/streets-v11",
						tileSize: 512,
						zoomOffset: -1,
						accessToken: process.env.VUE_APP_MAP_TOKEN,
					}
				);

				//Create the map
				this.map = L.map("map", {
					editable: true,
					preferCanvas: true,
					layers: [streetMap],
					attributionControl: false,
				}).setView([40.6306037, -3.1666264], 18);

				L.control
					.attribution({
						position: "bottomleft",
					})
					.addTo(this.map);

				//Then add the tile layer for satellite

				var baseLayers = {
					Satélite: satelliteStreetMap,
					Mapa: streetMap,
				};

				L.control
					.layers(baseLayers, {}, { position: "bottomright" })
					.addTo(this.map);

				//Create polyline
				this.polyline = new L.Polyline([], {
					color: "red",
					weight: 3,
					opacity: 0.5,
					smoothFactor: 1,
				});

				this.polyline.addTo(this.map);
				this.polyline.enableEdit();
				this.polyline.editor.continueForward();

				this.map.on("editable:vertex:contextmenu", (e) => {
					e.vertex.delete();
				});

				this.map.on("editable:vertex:click", (e) => {
					e.cancel();

					this.polyline.addLatLng([e.latlng.lat, e.latlng.lng]);
					this.polyline.disableEdit();
					this.polyline.enableEdit();
					this.polyline.editor.continueForward();
					return;
				});
			},

			/**
			 * Clears file input and all lines/markers
			 */
			resetRoute() {
				this.polyline.disableEdit();
				this.polyline.setLatLngs([]);
				this.$refs.fileInput.clearableCallback();
				this.polyline.enableEdit();
				this.polyline.editor.continueForward();
			},

			/**
			 * Fetches existing tags
			 */
			async fetchTags() {
				try {
					this.tagsLoading = true;
					const response = await axios.get("/races/tags");
					this.existingTags = response.data;
				} catch (error) {
					//No tags is not a problem
					this.existingTags = [];
				} finally {
					this.tagsLoading = false;
				}
			},

			/**
			 * Fetches circuits
			 */
			async fetchCircuits() {
				try {
					this.circuitsLoading = true;
					const response = await axios.get("/circuits");
					this.circuits = response.data.circuits;
				} catch (error) {
					//No circuits is not a problem
					this.circuits = [];
				} finally {
					this.circuitsLoading = false;
				}
			},
		},
		async mounted() {
			this.initializeMap();
			this.fetchTags();
			this.fetchCircuits();

			try {
				await axios.post("/is-admin");
			} catch (error) {
				this.$router.push({ name: "AdminLogin" });
			}
		},
	};
</script>

<style lang="scss" scoped>
	.map {
		height: 75vh;
		width: 100%;
		z-index: 0;
	}

	@import "../../scss/_mixins.scss";
	@import "../../scss/_variables.scss";
	.create-race {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;

		background-color: #f0f0f3;
		padding: 2em;

		.create-race-card {
			width: 100%;
			max-width: 1400px;
			height: fit-content;

			.create-race-form {
				padding: 2em;
			}

			.create-race-header {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				margin: 0;
				padding: 2em;
				background: #292931;

				h1 {
					flex: 1;
					padding: 0 0.5em;
					color: #fff;
					font-size: 2.5em;
				}
			}

			.price-field {
				width: fit-content;
			}

			.card-row {
				display: grid;
				grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
				column-gap: 1em;
			}

			.card-actions {
				margin-top: 2em;
				padding: 0;
			}
		}
	}
</style>

<style lang="scss">
	.leaflet-div-icon:first-of-type {
		background-color: var(--v-success-base);
		border-radius: 50%;
		width: 16px !important;
		height: 16px !important;
		position: relative;
		top: -4px;
		left: -4px;
	}
</style>
